(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-bossnet-contact]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const panel = form.closest('[data-contact-bridge]');
      const submit = form.querySelector('[data-contact-submit]');
      const generalError = panel.querySelector('[data-contact-error]');
      const success = panel.querySelector('[data-contact-success]');
      const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]):not([name="website"]), textarea, select'));
      const originalLabel = submit.innerHTML;
      let sending = false;
      let completed = false;
      let lastPayload = '';
      let requestId = ''; 

      const fieldError = (field, message = '') => {
        const error = document.getElementById(field.getAttribute('aria-describedby'));
        if (error) {
          error.textContent = message;
          error.hidden = !message;
        }
        if (message) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      };
      const validate = (field) => {
        if (field.required && (field.type === 'checkbox' ? !field.checked : !field.value.trim())) {
          return field.type === 'checkbox'
            ? window.EdenI18n.t("text_92bc4248d015")
            : window.EdenI18n.t("text_2e93fb482756");
        }
        if (field.validity.typeMismatch) return window.EdenI18n.t("text_cd728cc86cc4");
        if (field.name === 'telefon' && field.value.trim()) {
          const value = field.value.trim();
          const digits = value.replace(/\D/g, '');
          if (!/^[+0-9(). \-]+$/.test(value) || digits.length < 7 || digits.length > 20) {
            return window.EdenI18n.t("text_7bd9fefd3200");
          }
        }
        if (!field.validity.valid) return window.EdenI18n.t("text_641a7108d433");
        return '';
      };
      fields.forEach((field) => {
        field.addEventListener('input', () => fieldError(field));
        field.addEventListener('change', () => fieldError(field));
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (sending || completed) return;
        generalError.hidden = true;
        let firstInvalid;
        fields.forEach((field) => {
          const message = validate(field);
          fieldError(field, message);
          if (message && !firstInvalid) firstInvalid = field;
        });
        if (firstInvalid) {
          firstInvalid.focus();
          return;
        }

        sending = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = window.EdenI18n.t("text_c7a35e52aef4");
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 65000);
        const data = Object.fromEntries(new FormData(form).entries());
        data.pagina = window.location.origin + window.location.pathname;
        const signature = JSON.stringify(data);
        if (signature !== lastPayload) { requestId = crypto.randomUUID(); lastPayload = signature; }
        data.request_id = requestId;
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            redirect: 'error',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            signal: controller.signal,
          });
          const result = await response.json();
          if (!response.ok || result.ok !== true) {
            if (result.fields && typeof result.fields === 'object') {
              fields.forEach((field) => {
                if (typeof result.fields[field.name] === 'string') fieldError(field, window.EdenI18n.en ? window.EdenI18n.t('text_641a7108d433') : result.fields[field.name]);
              });
              const invalid = form.querySelector('[aria-invalid="true"]');
              if (invalid) {
                invalid.focus();
                return;
              }
            }
            throw new Error('Delivery failed');
          }
          completed = true;
          const formFields = panel.querySelector('[data-contact-fields]');
          if (panel.hasAttribute('data-contact-preserve-height')) {
            // Invisible, inert fields retain the form's height, including on resize.
            formFields.inert = true;
            formFields.setAttribute('aria-hidden', 'true');
            panel.classList.add('is-complete');
          } else {
            formFields.hidden = true;
          }
          success.hidden = false;
          success.focus({ preventScroll: true });
          success.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        } catch (_error) {
          generalError.hidden = false;
        } finally {
          window.clearTimeout(timer);
          sending = false;
          submit.disabled = completed;
          submit.removeAttribute('aria-busy');
          submit.innerHTML = originalLabel;
        }
      });
      form.noValidate = true;
      submit.disabled = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
